import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getNotificationByUserId,
  getNotifications,
  addNotification,
  deleteNotifiation,
  getUnreadNotification,
  getReadNotification,
} from "./notificationApi";

// Thunks
export const fetchNotifications = createAsyncThunk(
  "meetings/fetchNotifications",
  async (paramsOptions) => {
    const response = await getNotifications(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);
export const fetchUnreadNotifications = createAsyncThunk(
  "meetings/fetchUnreadNotifications",
  async () => {
    const response = await getUnreadNotification();
    return response.data;
  }
);

export const fetchReadNotifications = createAsyncThunk(
  "meetings/fetchReadNotifications",
  async () => {
    const response = await getReadNotification();
    return response.data;
  }
);


export const fetchNotificationByUserId = createAsyncThunk(
  "meetings/getNotificationByUserId",
  async (paramsOptions) => {
    const response = await getNotificationByUserId(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const createNotification = createAsyncThunk(
  "meetings/createmeeting",
  async (data) => {
    const response = await addNotification(data);
    return response;
  }
);

export const deleteNotificatonById = createAsyncThunk(
  "meetings/deletemeeting",
  async (id) => {
    const response = await deleteNotifiation(id);
    return response;
  }
);

const meetingslice = createSlice({
  name: "notifications",
  initialState: {
    notifications: [],
    pagination: {},
    unreadCount: "",
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.notifications = data;
        state.pagination = pagination;
      })
      .addCase(fetchNotificationByUserId.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.notifications = data;
        state.pagination = pagination;
      })
      .addCase(fetchUnreadNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.unreadCount = action.payload;
      })
      .addCase(fetchReadNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.unreadCount = action.payload;
      })
      .addCase(createNotification.fulfilled, (state, action) => {
        state.notifications.push(action.payload.data);
      })
      .addCase(deleteNotificatonById.fulfilled, (state, action) => {
        state.notifications = state.notifications.filter(
          (u) => u.id !== action.payload.id
        );
      });
  },
});

export default meetingslice.reducer;
